export default __webpack_public_path__ + "locales/hy-AM/Webhooks.json?hash=9e6e10b64788043a71ef8e21817d4ce3";